module.exports = __webpack_public_path__ + "img/b4572f5ba883caa1c3b30a218246fe3b.e4da9e32.jpg";